export class Log {
  /**
   * @param {string} text
   */
  public logToNewWindow(text: string) {
    let popup: Window | null = window.open(
      "",
      "myconsole",
      "width=350,height=250" +
        ",menubar=0" +
        ",toolbar=1" +
        ",status=0" +
        ",scrollbars=1" +
        ",resizable=1"
    );

    if (popup) {
      popup.document.writeln(
        "<html><head><title>Console</title></head>" +
          '<body bgcolor=white onLoad="self.focus()">' +
          text +
          "</body></html>"
      );
      popup.document.close();
    }
  }
}
